import { useEffect } from "react";

import styled from "styled-components/macro";

import { useSignups } from "Signups/state";

import useFamilyRegistrationAdminPermissions from "../Shared/useFamilyRegistrationAdminPermissions";

import AdminPanelContent from "./AdminPanelContent";
import AdminPanelFooter from "./AdminPanelFooter";
import AdminPanelHeader from "./AdminPanelHeader";

export default function FamilyRegistrationAdminPanelView() {
  const [state] = useSignups();
  const {
    canViewFamilyRegistrationAdminPanel,
    hasFamilyRegistration,
    initialDataLoaded,
  } = state;

  const { shouldShowAdminPanelView } = useFamilyRegistrationAdminPermissions();

  useEffect(
    function redirectIfNoFamilyRegistration() {
      if (!initialDataLoaded) return;
      if (!canViewFamilyRegistrationAdminPanel) {
        window.fnReactBus.replaceUrl("/signups");
      }
    },
    [
      canViewFamilyRegistrationAdminPanel,
      hasFamilyRegistration,
      initialDataLoaded,
    ]
  );

  if (!shouldShowAdminPanelView) return null;

  return (
    <Wrapper className="family-registration-panel">
      <Content>
        <AdminPanelHeader />
        <AdminPanelContent />
        <AdminPanelFooter />
      </Content>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  font-weight: 400;
  overflow: hidden;
`;

const Content = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  position: relative;
`;
